import { render } from "./BallotBox.vue?vue&type=template&id=2ffd1f26&scoped=true"
import script from "./BallotBox.vue?vue&type=script&lang=js"
export * from "./BallotBox.vue?vue&type=script&lang=js"

import "./BallotBox.vue?vue&type=style&index=0&id=2ffd1f26&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ffd1f26"]])

export default __exports__